import React, {useState, useEffect} from 'react';
import '../../css/callLog.css';
import { getVoicemails, removeVoicemail, voicemailHeard } from '../../utilities/phoneRelatedFunctions';
import { formatPhoneNumber } from '../../utilities/dashFunction';
import {setOpenVoicemails} from '../../features/topBarSlice';
import { setVoicemails, setUnheard, deleteVoicemailRecording } from '../../features/voicemailSlice';
import { useSelector, useDispatch } from 'react-redux';
import image from '../../assets/icons/loading-loader.gif';
import Icon from '../../assets/icons/icon';
import AudioPlayer from 'react-audio-player';


function Voicemails({openLead}) {
    const dispatch = useDispatch();
    const isFeature983Enabled = process.env.REACT_APP_FUNNEL_FEATURE_983 === 'true'
    const agentInfo=useSelector((state) => state.agent.userData);
    const voicemailState=useSelector((state) => state.topBar.voicemails);
    const voicemails=useSelector((state) => state.voicemails.voicemails);
    const [callsLoading, setVoicemailLoading] = useState(false);
    useEffect( () => {
        if(voicemailState){
            if(voicemails.length < 1){
                getVoicemails(agentInfo.agentId, setVoicemailLoading, setVoicemails, dispatch);
            }
        }
    },[voicemailState])
    function updateHeard(voicemailsArr, id) {
        return voicemailsArr.map(item => {
            if (item.id === id) {
                return { ...item, message_heard: 'yes' }; // Update the matching item
            }
            return item; // Return the item unchanged if the id does not match
        });
    }
    const hearLead=(heard, id)=>{
        if(heard==='no'){
            const newVoicemails=updateHeard(voicemails, id)
            voicemailHeard(id);
            dispatch(setUnheard(-1));
            dispatch(setVoicemails(newVoicemails));
        }
    }
    const handleClose=()=>{
        dispatch(setOpenVoicemails(false));
    }
    const handleDeleteVm= async (id, heard)=>{
        const removed=await removeVoicemail(id);
        if(heard==='no'){
            dispatch(setUnheard(-1));
        }
        if(removed){
            dispatch(deleteVoicemailRecording(id));
        }
    }

    function formatTimestamp(timestamp, timezone, showTime, showSecond) {
        timezone = timezone ?? 'Asia/Kolkata';
        showTime = showTime ?? true;
        showSecond = showSecond ?? false;
    
        const date = typeof timestamp === 'string'
            ? new Date(timestamp)
            : new Date(timestamp * 1000);
    
        if (isNaN(date.getTime())) return 'Invalid Date';
    
        const option = {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            ...(showTime && {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
                ...(showSecond && { second: '2-digit' })
            }),
            ...(isFeature983Enabled && timezone && { timeZone: timezone })
        };
    
        return date.toLocaleString('en-US', option);
    }

    return (
        <>
            <div className={`leaderBoardWrapper ${voicemailState ? 'openedLeaderBoard': ''}`}>
                {callsLoading && (
                    <div className="smallLoadingWrapper">
                        <div className="innerSmallLoadingWrapper">
                            <img src={image} alt="Loading Gif" style={{width: '100%'}} />
                        </div>
                    </div>
                )} 
                <div className="quilityCloseWindow" onClick={()=>handleClose()} style={{zIndex: '2'}}><span className="fontello"><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div> 
                <div className="leaderBoardHeader">
                    <div className="leaderBoardTitle">Voicemails</div>
                    
                </div>
                <div className="convoEntireWrapper">
                    <div className={`conversationLeft`}>
                        <div className="convoListInnerWrapper">
                            <div className="voicemailsBody">
                                {voicemails && voicemails.map((voicemailItem, index) => (
                                    <div key={`voicemailRecording${index}`}className={`callItemWrapper ${voicemailItem.message_heard==='no' ? 'unheard':''}`} onClick={()=>{hearLead(voicemailItem.message_heard, voicemailItem.id);voicemailItem.lead_id !=='none' && openLead(voicemailItem.lead_id)}}>
                                        <span className="reveal"><div className="quilityDestructiveClose" onClick={(e)=>[handleDeleteVm(voicemailItem.id, voicemailItem.message_heard), e.stopPropagation()]} style={{zIndex: '2'}}><span className="fontello"><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" /></span></div> </span>
                                        <div className="callLogBlock">
                                            {voicemailItem.borrower_first ? (
                                                <span className="quilityDataLineTitle">{voicemailItem.borrower_first} {voicemailItem.borrower_last}</span>
                                            ) : (
                                                <span className="quilityDataLineTitle">{voicemailItem.message_from}</span>
                                            )}
                                            <div className="subLineWrapper">
                                                <span className={`directionIndication`}><span className="fontello"><Icon name={'q-voicemail'} size={18} className="" adjust="fontello" /></span></span>
                                                <span className="callWithItem">{formatPhoneNumber(voicemailItem.message_from)}</span> - 
                                                <span className="callWithItem">{formatTimestamp(voicemailItem.formatted_timestamp)}</span>
                                            </div>
                                            <span className="quilityDataLineValue">
                                                <AudioPlayer
                                                    src={voicemailItem.url}
                                                    autoPlay={false}
                                                    controls
                                                    className=""
                                                    onPlay={()=>hearLead(voicemailItem.message_heard, voicemailItem.id)}
                                                />
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Voicemails;
